__webpack_require__.p = "/design-system/";